import { StatusModal } from "@components";
import { Download01 } from "@untitledui/icons";
import { CheckCircle2 } from "lucide-react";

const DEFAULT_SUCCESS_MESSAGE =
	"Exportação solicitada. O relatório será enviado para o seu e-mail assim que estiver pronto.";

type ExportSuccessModalProps = {
	isOpen: boolean;
	onClose: () => void;
	/** Prefer the `message` returned by POST /api/export (already localized). */
	message?: string | null;
};

export function ExportSuccessModal({
	isOpen,
	onClose,
	message,
}: ExportSuccessModalProps) {
	return (
		<StatusModal
			actions={[
				{
					iconLeading: (
						<CheckCircle2 className="size-5 text-button-primary-icon" />
					),
					label: "Ok",
					onClick: onClose,
				},
			]}
			description={message?.trim() || DEFAULT_SUCCESS_MESSAGE}
			icon={
				<Download01 className="absolute top-6 left-6 size-12 rounded-full bg-bg-brand-secondary p-3 text-fg-brand-primary" />
			}
			isOpen={isOpen}
			onClose={onClose}
			title="Exportação solicitada com sucesso"
			variant="success"
		/>
	);
}
